export default class KeyValueWithTypeAndPositionErrorModel {
    constructor(
        public name: string = "",
        public type: string = "",
        public value: string = ""
    ) { }
}